<template>
  <div :class="`document-navigation ${isActive ? 'document-navigation--active' : ''}`">
    <div class="document-navigation__image document-navigation__image--prev">
      <template v-if="prevDoc !== undefined">
        <img :src="`https://docs-cdn.signable.co.uk/large/${prevDoc.fingerprint}-0.jpg`" />
        <a class="document-navigation__button document-navigation__button--prev"
          href="javascript:;"
          @click="goToPrevDoc">
          <icon name="chevron-left" height="14" width="14"></icon>
        </a>
        <div class="document-navigation__title">
          <span>{{ prevDoc.title }}</span>
          <span class="document-navigation__arrow"></span>
        </div>
      </template>
      <template v-else>
        <div class="document-navigation__image-placeholder"></div>
      </template>
    </div>
    <div class="document-navigation__image" v-if="currentDoc !== undefined">
      <img :src="`https://docs-cdn.signable.co.uk/large/${currentDoc.fingerprint}-0.jpg`" />
      <div class="document-navigation__title">
        <span>{{ currentDoc.title }}</span>
        <span class="document-navigation__arrow"></span>
      </div>
    </div>
    <div class="document-navigation__image document-navigation__image--next">
      <template v-if="nextDoc !== undefined">
        <img :src="`https://docs-cdn.signable.co.uk/large/${nextDoc.fingerprint}-0.jpg`" />
        <a class="document-navigation__button document-navigation__button--next"
          href="javascript:;"
          @click="goToNextDoc">
          <icon name="chevron-right" height="14" width="14"></icon>
        </a>
        <div class="document-navigation__title">
          <span>{{ nextDoc.title }}</span>
          <span class="document-navigation__arrow"></span>
        </div>
      </template>
      <template v-else>
        <div class="document-navigation__image-placeholder"></div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'document-navigation',
    data() {
      return {
        isActive: false,
        currentDoc: undefined,
        prevDoc: undefined,
        nextDoc: undefined,
      };
    },
    created() {
      this.$bus.$on('scrolledToBottom', ({ isBottom }) => {
        if (isBottom) {
          const state = this.$store.state;
          this.currentDoc = this.$store.getters.document(state.currentDocument);
          this.prevDoc = this.$store.getters.document(state.currentDocument - 1);
          this.nextDoc = this.$store.getters.document(state.currentDocument + 1);
        }
        this.isActive = isBottom;
      });
    },
    methods: {
      goToNextDoc() {
        const index = this.$store.state.currentDocument + 1;
        this.$store.commit('nextDocument', { index });
        this.$bus.$emit('nextDocument');
      },
      goToPrevDoc() {
        const index = this.$store.state.currentDocument - 1;
        this.$store.commit('nextDocument', { index });
        this.$bus.$emit('nextDocument');
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass'
  .document-navigation
    padding: $spacing-small
    background: rgba(0, 0, 0, 0.8)
    border-radius: 3px
    position: absolute
    bottom: 87px
    left: 50%
    transform: translate3d(-50%, 0, 0) perspective(600px) rotateX(50deg) scale(0.9)
    transform-origin: 67px 67px 40px
    opacity: 0
    transition: all .25s ease
    @include clearfix
    &--active
      transform: translate3d(-50%, 0, 0) perspective(0px) rotateX(0deg) scale(1)
      opacity: 1
    &__image
      max-width: 70px
      height: 100px
      float: left
      border-radius: 2px
      box-shadow: 0px 0px 15px 0px #333
      position: relative
      z-index: 1
      &:first-child
        margin-left: 0
      &:hover
        .document-navigation__title
          display: block
      img
        display: block
        height: 100%
      &--prev,
      &--next,
      &-placeholder
        max-width: 60px
        height: 75px
        margin-top: 12px
        border: 0
        box-shadow: initial
        z-index: 0
        .document-navigation__title
          top: -65px
    &__image-placeholder
      background-color: #666
      width: 60px
      margin-top: 0
    &__title
      position: absolute
      top: -53px
      white-space: nowrap
      background: rgba(0, 0, 0, 0.8)
      color: #fff
      padding: 5px 10px
      border-radius: 3px
      left: 50%
      transform: translate3d(-50%, 0, 0)
      display: none
    &__arrow
      @include arrow('bottom', #333, 5px, true)
    &__button
      position: absolute
      color: #fff
      z-index: 10
      line-height: 0
      padding: 10px
      background: $signable-secondary-1
      border-radius: 30px
      top: 50%
      transform: translate3d(0, -50%, 0)
      &--next
        right: -50px
      &--prev
        left: -50px
      svg
        margin: 0
  // Responsive
  @media screen and (max-width: $screen-size-small)
    .document-navigation
      &__image
        max-width: 60px
        &--next,
        &--prev,
        &-placeholder
          max-width: 50px
</style>



// WEBPACK FOOTER //
// DocumentNavigation.vue?06bbee86